module.exports = __webpack_public_path__ + "img/entreprises.a1d46981.png";